import React, { FC, useContext } from 'react';
import { FeedEditorCtx } from '@go-client/context/FeedEdtitorContext';
import { makeEventSorter } from '@go-shared/lib/event';
import { generateTimeString } from '@go-shared/lib/event';
import { Event } from '@go-shared/types/event';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { getCommonTexts } from '@go-shared/lib/brand';
import { DEFAULT_HOUR_FORMAT } from '@go-shared/lib/time';

const WELLNESS_VENUE_IDS = [
  '5a4bf486da0c112a66ed62f9',
  '5a4bf486da0c112a66ed62fb',
  '5a4bf486da0c112a66ed62ff',
  '5e19895e3046aa513d06d267',
  '5a4bf486da0c112a66ed632d',
];
export const WellnessRundown: FC<{}> = () => {
  let { events } = useContext(FeedEditorCtx);
  const { brand, defaultLanguage } = useServerInfo();
  const { commonTextTranslations } = useContext(FeedEditorCtx);

  const commonTexts = getCommonTexts(
    {
      default: brand.commonTexts,
      translations: commonTextTranslations,
    },
    { selected: defaultLanguage.key }
  );

  let eventSorter = makeEventSorter(360);
  let wellnessEventsByVenue: any = [];
  WELLNESS_VENUE_IDS.forEach(vid => {
    let filteredEvents = events.filter(e => e.venue._id === vid);
    filteredEvents.sort(eventSorter);

    let eventsInVenue: Array<Event & { timeString: string }> = filteredEvents.map(e => {
      return {
        ...e,
        timeString: generateTimeString(
          e.startTime,
          e.duration,
          DEFAULT_HOUR_FORMAT,
          commonTexts,
          e.interactiveFeedDisplay,
          e.template.interactiveFeedDisplay
        ),
      };
    });

    if (eventsInVenue.length > 0) {
      let venue = eventsInVenue[0].venue;
      wellnessEventsByVenue.push({
        venue: `${venue.name.toUpperCase()} (DK ${venue.level})`,
        events: eventsInVenue,
      });
    }
  });

  return (
    <div>
      {wellnessEventsByVenue.map((ee: any) => (
        <div className="mt-4">
          <h2 className="WellnessRundownVenue">{ee.venue}</h2>
          <div className="WellnessRundownEvents">
            {ee.events.map((e: any) => (
              <div className="flex">
                <div className="WellnessRundownEventTitle">{e.template.title}</div>
                <div className="flex-grow" />
                <div>{e.timeString}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
